import "@Styles/mandate.css";
import ProgressBar from "@ramonak/react-progress-bar";
import moment from "moment";
import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import belowtextimg from "../../../Images/NewUI/belowheadingnew.png";
import WhiteSpark from "../../../Images/NewUI/circle-arrow.png";
import Line from "../../../Images/NewUI/Line.png";
import RepayImg from "../../../Images/NewUI/RepayImg.png";
import SlideOne from "../../../Images/NewUI/SlideOne.png";
import SlideOneOverDue from "../../../Images/NewUI/SlideOneOver1.png";
import SlideThree from "../../../Images/NewUI/SlideThree.png";
import SlideThreeOverDue from "../../../Images/NewUI/SlideThreeOver3.png";
import SlideTwo from "../../../Images/NewUI/SlideTwo.png";
import SlideTwoOverDue from "../../../Images/NewUI/SlideTwoOver2.png";
import alertIcon from "../../../Images/NewUI/alert.png";
import bell from "../../../Images/NewUI/blackbell.png";
import Calander from "../../../Images/NewUI/calender.png";
import bellnotify from "../../../assets/bellnifify.png";
import exclamation from "../../../Images/NewUI/exclaim.png";
import greenDot from "../../../Images/NewUI/green.png";
import InstantLoan from "../../../Images/NewUI/instantloanimg.png";
import PersonalLoan from "../../../Images/NewUI/personalloan.png";
import ToastMsg from "../../../helper/ToastMsg";
import Header from "../Common/Headerr";
import { Loader } from "../Common/Loader";
import PreCloserTile from "../../NewUI/User/NewUser/SuperAppComponents/PreCloserLoan"

const RepayDashboard = (props) => {
  const { event = "loan", canApply = true, userType = "old" } = props;
  
  const navigate = useNavigate();
  
  const user = useSelector((state) => state.user);
  const {
    loading,
    loanStatus: loanData,
    documentStatus,
    hasReadNotification: isNotify,
    precloserShow,
  } = useSelector((state) => state.dashboard);

  // const token = user?.User?.token || localStorage.getItem("gpay_token");
  
  const [isButtonDisabled, setisButtonDisabled] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const repayment_screen = loanData?.repayment_screen_show || "";
  const loanId = loanData?.loan_id || "";
  const totalAmount = loanData?.amount || 0;
  const disbursedAmount = loanData?.disbursal_amount || 0;
  const collectionAmount = loanData?.collection_amount || 0;
  const balanceAmount = loanData?.due_amount || 0;
  const rateOfInterest = loanData?.fee_at_that_time?.current_roi || 0.1;
  const nBFCName = loanData?.nbfc_first_name || "";
  const foreClosure = loanData?.foreclosure_loan || false;
  const loan_type = loanData?.loan_type || "P";

  const { dueAmount, repaymentDate } = useMemo(() => {
    if (!loanData) return { dueAmount: 0, repaymentDate: "" };
    
    if (loanData?.loan_type === "P") {
      return {
        dueAmount: loanData?.due_amount || 0,
        repaymentDate: loanData?.repayment_date || "",
      };
    } else {
      let allEmiAmount = 0;
      let unpaidIndex = false;
      let repayDate = "";
      const emiDetails = loanData?.emi_details || [];
      
      for (let i = 0; i < emiDetails.length; i++) {
        if (emiDetails[i].status === "UNPAID") {
          allEmiAmount += emiDetails[i]?.due_amount || 0;
          const today = new Date();
          const isRepaymentDateAfterToday = new Date(emiDetails[i]?.repayment_date) > today;
          if (!unpaidIndex) {
            repayDate = emiDetails[i]?.repayment_date || "";
          }
          unpaidIndex = true;
          if (isRepaymentDateAfterToday) {
            break;
          }
        }
      }
      return { dueAmount: allEmiAmount, repaymentDate: repayDate };
    }
  }, [loanData]);

  const modalClose = () => setIsOpen(false);

  const handleClick = () => navigate("/loanstatusemi", { state: { loan_id: loanId } });

  const applyloan = () => {
    if (repayment_screen === "repayment_screen") {
      navigate("/loan_repay");
    } else if (isButtonDisabled) {
      ToastMsg("Your repayment will be auto debited via ECS", "success");
      setisButtonDisabled(false);
      setTimeout(() => setisButtonDisabled(true), 4000);
    }
  };

  const progressValue = (100 * collectionAmount) / (balanceAmount + collectionAmount);

  const Arrow = ({ type, onClick }) => (
    <span className={`${type === "next" ? "nextArrow" : "prevArrow"} arrow`} onClick={onClick} />
  );

  const getDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  };

  const formattedRepayDate = moment(repaymentDate).format("YYYY-MM-DD");
  const todayFormatted = moment().format("YYYY-MM-DD");
  const result = Number(getDaysDifference(formattedRepayDate, todayFormatted));

  const Images = [SlideOne, SlideTwo, SlideThree];

  const renderSlides = () =>
    Images.map((item, index) => (
      <div key={index}>
        <img style={{ maxWidth: "320px", paddingRight: "10px" }} src={item} alt="slide" />
      </div>
    ));

  const OverdueImages = [SlideOneOverDue, SlideTwoOverDue, SlideThreeOverDue];

  const renderSlidesOverdue = () =>
    OverdueImages.map((item, index) => (
      <div key={index}>
        <img width={302} src={item} alt="overdue-slide" />
      </div>
    ));

  const handleNotificationredirection = () => {
    setTimeout(() => {
      window.location.href = "/notifications";
    }, 100);
  };

  useEffect(() => {
    if (result > 7 || result < 1) {
      setIsOpen(false);
    } else if (result <= 7 && result >= 1) {
      const timeoutId = setTimeout(() => setIsOpen(true), 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [result]);

  return (
    <div>
      {loading && <Loader />}
      <div >
        <div className="main_div payme_body bg_white">
          <div className="UpperImgdiv">
            <article className="article">
              <picture className="picture">
                <source media="(min-width: 0px)" srcSet={RepayImg} />
                <img
                  className="NewDashboardImg"
                  src={RepayImg}
                  alt="background"
                  height={245}
                />
              </picture>
              
              <div className="m-t-dashboardheader header pd-l-r-zeroUpdate container ">
              <div className="flex_row justifycontentSpacebetn">
                  <Header via={"repay"}/>
                  <div className="flex ">
                    <span className="notify">
                    </span>
                    <span className="notify belldesignrepay" 

                    onClick={handleNotificationredirection}
                    >
  <div className="flex items-center">

    <div onClick={handleNotificationredirection}>
      {isNotify ? (
        <img
          src={bell}
          alt="img"
          width={"27px"}
          height={"27px"}
        />
      ) : (
        <img
          src={bellnotify}
          alt="img"
          width={"27px"}
          height={"30px"}
          style={{ marginTop: "5px" }}
        />
      )}
    </div>
  </div>
</span>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <div
            style={{ marginTop: -118, marginBottom: -50 }}
            className="cardbottomMargin aligncentrehere"
          >
            <div
              className="cardstructurerepay-super-app-repay pb-12 pt-2"
            >
              <div className="flex_row justifycontent  flex_end">
                <div className="flex_row ">
                  <div className="majorAmountdiv">
                    <span className="activeLoan">
                      <img
                        className="m-br-r"
                        src={greenDot}
                        alt="img"
                        width={"12px"}
                        height={"12px"}
                      />{" "}
                      Active Loan &nbsp;{" "}
                    </span>
                 
                    <div
                      style={{ marginTop: 8, marginBottom: 4 }}
                      className="flex_row align_centre"
                    >
                      <span className="boldtextsuperApp">
                        {loan_type === "P" ? "Payable Amount:" : "EMI Amount:"}
                      </span>
                    </div>
                    <span style={{ fontSize: 24, fontWeight: 700 }}>
                      <span style={{ fontWeight: 400, marginRight: 1 }}>₹</span>
                      {dueAmount
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}{" "}
                    </span>
                    <br />
                  </div>
                </div>

                {result > 0 ? (
                  <div
                    style={{ marginRight: 10, marginBottom: "24px" }}
                    className=" displayfix align_centre "
                  >
                    <img
                      className="calender_fix"
                      style={{ width: 34, height: 34, marginBottom: 0 }}
                      src={alertIcon}
                      alt="calendergreen"
                    />
                    <span className="Overdueby" style={{ color: "red" }}>
                      <span className="Overdueby ">Overdue by </span>
                      {Math.abs(result)} Days{" "}
                    </span>
                  </div>
                ) : result === 0 ? (
                  <div
                    style={{ marginRight: 10 }}
                    className="displayfix align_centre "
                  >
                    <img
                      style={{ width: 48, height: 52, marginBottom: 5 }}
                      src={Calander}
                      alt="calendergreen"
                    />
                    <span style={{ color: "rgba(22, 201, 111, 1)" }}>
                      Today is your due date
                    </span>
                  </div>
                ) : (
                  <div
                    style={{ marginRight: 10 }}
                    className=" displayfix align_centre "
                  >
                    <img
                      style={{ width: 48, height: 52, marginBottom: 5 }}
                      src={Calander}
                      alt="calendergreen"
                    />
                    <span
                      style={{
                        color: "rgba(22, 201, 111, 1)",
                        fontWeight: "600",
                      }}
                    >
                      <span>{Math.abs(result)}</span> Days left 
                    </span>
                  </div>
                )}
              </div>

              {loan_type === "E" ? (
                <div style={{ marginTop: "6px" }} className="superapp-repay ">
                  <div className="repayui">
                    <span
                      style={{ marginRight: "5px" }}
                      className="repay-font boldtextsuperApp"
                    >
                      Due on:{" "}
                    </span>
                    <br />
                    <span className="repay-font-one">
                      {" "}
                      {moment(repaymentDate).format("DD/MM/YYYY")}{" "}
                    </span>
                  </div>
                  <img
                    className={!loan_type === "E" ? "linefix" : "linefixnew"}
                    src={Line}
                    alt="Line"
                  />
                  <div className="repayui">
                    <span
                      style={{ marginRight: "5px" }}
                      className="repay-font boldtextsuperApp"
                    >
                      {" "}
                      Total Amount:
                    </span>
                    <br />
                    <span className="rupeEsign2">₹</span>
                    <span className="repay-font-one">
                      {totalAmount
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                    </span>
                  </div>

                  
                </div>
              ) : (
                " "
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "row",
                  gap: "20px",
                  marginBottom: "20px",
                  marginTop: "7px",
                }}
                className=""
              >
                <span>
                  {" "}
                  {loan_type === "P" ? (
                    <div>
                      <span className="gray_text boldtextsuperApp">
                        Due on :
                      </span>{" "}
                      {moment(repaymentDate).format("DD/MM/YYYY")}{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </span>
                {loan_type === "P" ? (
                  <img className="linefixrepay" src={Line} alt="Line" />
                ) : (
                  ""
                )}

                <span>
                  {loan_type === "P" ? (
                    <div>
                      <span className="gray_text">Total Amount :</span> ₹
                      {totalAmount
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                    </div>
                  ) : (
                    ""
                  )}
                </span>
              </div>

              <div style={{ marginBottom: "3px" }} className="mt-9">
                <div onClick={applyloan} className="super-app-btn-new ">
                  <span>Repay Now</span>
                  <img
                    src={WhiteSpark}
                    style={{ marginLeft: "5px" }}
                    height={16}
                    width={16}
                  />
                </div>
              </div>
              {foreClosure && (
                <div onClick={()=>{navigate("/loan_foreclosure");}} className="textCenter">
                  <div className="closureLoanText text-center">
                    Foreclose Loan
                  </div>
                </div>
              )}
            </div>

          {precloserShow && <PreCloserTile />}
            {result < 1 ? (
              <>
                <div className="toolbarRespo mt-20 ">
                  <span className="superapprepaycenter-text">
                    Benefits of Timely Repayment
                  </span>
                  <img
                    className="mb-10 mt-2"
                    src={belowtextimg}
                    width={252}
                    height={4}
                  />
                </div>
                <div  className="App maxwidth460 ">
                  <Slider
                    nextArrow={<Arrow type="next" />}
                    prevArrow={<Arrow type="prev" />}
                    autoplay={true}
                    autoplaySpeed={3000}
                    dots={true}
                  >
                    {renderSlides()}
                  </Slider> 
                </div>
                <br />
              </>
            ) : (
              <>
                <div className="App container maxwidth460 overdueSlider">
                  <p className="didYouKnow textalignInitial">Did you know:</p>
                  <div className="exclaminationFix">
                    <img
                      className="ml-6"
                      src={exclamation}
                      alt="img"
                      width={"12px"}
                      height={"12px"}
                    />
                    <p className="didYouKnowBelow textalignInitial mb-9 ml-6">
                      Untimely repayment of loan will affect your cibil score.
                    </p>
                  </div>
                  <p className="didYouKnowBelowone textalignInitial ml-6">
                    How can Low Credit Score impact your daily life?
                  </p>

                  <Slider
                    nextArrow={<Arrow type="next" />}
                    prevArrow={<Arrow type="prev" />}
                    autoplay={true}
                    autoplaySpeed={3000}
                    dots={true}
                  >
                    {renderSlidesOverdue()}
                  </Slider>
                </div>
              </>
            )}

            <br />
            <div className="container pd-l-r-zeroUpdate ">
              <span className="superapprepaycenter-text">Loan Details</span>
              <br />
              <img
                className="mb-10"
                src={belowtextimg}
                width={140}
                height={4}
              />
            </div>
            <div className="cardstructurerepay-super-app-repay mb-57">
              <div className="flex_row justifycontent  alignCentre ">
                <div className="flex_row">
                  <div className="majorAmountdiv">
                    <div
                      style={{ marginTop: 8, marginBottom: 10 }}
                      className="flex_row align_centre"
                    >
                      {loan_type !== "P" ? (
                        <img
                          className="personalLoanimg"
                          src={PersonalLoan}
                          alt="personalLoan"
                        />
                      ) : (
                        <img
                          className="personalLoanimg"
                          src={InstantLoan}
                          alt="instantloan"
                        />
                      )}
                      {loan_type == "P" ? (
                        <span className="boldtext f-t-600"> Instant Loan</span>
                      ) : (
                        <span className="boldtext"> EMI Loan</span>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  style={{ marginRight: 10 }}
                  className=" displayfix align_centre "
                >
                  <span className="viewdetails" onClick={handleClick}>
                  View Details
                </span>
                </div>
              </div>

              <div className="justifycontentSpacebetn flex_row managemarginrepay">
                <span className="gray_text mt-6new">Disbursed Amount</span>
                <span>
                  ₹
                  {disbursedAmount
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span>
              </div>

              <div className="justifycontentSpacebetn flex_row managemarginrepay">
                <span className="gray_text mt-6new">
                  {" "}
                  Interest rate per day
                </span>
                <span>{rateOfInterest} %</span>
              </div>

              <div className="justifycontentSpacebetn flex_row managemarginrepay">
                <span className="gray_text mt-6new">NBFC Name</span>
                <span>{nBFCName}</span>
              </div>

              <div className="pb-15 progressbar ">
                <ProgressBar
                  className="wrapperhere"
                  height="8px"
                  margin=" 2px 0px 0px 0px"
                  width="100%"
                  barContainerClassName="backgroundcolour"
                  completed={progressValue}
                  bgColor="#2788D9"
                  isLabelVisible={false}
                  animateOnRender={false}
                />
                <div className="justifycontentSpacebetn flex_row managemarginrepay mt-2">
                  <span className="repayemiamountetcfontstyle">
                    ₹{" "}
                    {collectionAmount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                    Paid
                  </span>
                  <span className="repayemiamountetcfontstyle">
                    ₹{" "}
                    {balanceAmount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                    Left
                  </span>
                </div>
              </div>
              <div className="OverdueModal">
                <Modal show={isOpen} centered className="loan_mn">
                  <Modal.Body>
                    <div className="popup-div text-center">
                      <span
                        onClick={modalClose}
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span className="repaymodalXbtn" aria-hidden="true">
                          &times;
                        </span>
                      </span>

                      <div className="overduePoppup">
                        <img
                          width={67}
                          src={alertIcon}
                          alt="Raised_Successfully"
                          className="pop_mob"
                        />
                        <span className="repaymodalredtext">
                          Payment Overdue
                        </span>
                        <span className="repaymodalGraytext">
                          Your payment is overdue by{" "}
                          <span>{Math.abs(result)}</span> days.
                        </span>
                        <br />
                        <span className="repaymodalGraytext">
                          Note: Payments made within 7 days of the due date will
                          not be reflected in your CIBIL report.
                        </span>
                        <div
                          onClick={applyloan}
                          className="button-wrapper text-center"
                        >
                          <a className="overdueBtn">Repay Now</a>
                        </div>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
           
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default RepayDashboard;
